
import React from 'react';
import { Link } from 'react-router-dom';
import { getStorageUrl } from '@/utils/storageUtils';
import { buildLogoUrl } from '@/utils/supabaseConfig';

interface SidebarHeaderProps {
  showLogo?: boolean;
}

export function SidebarHeader({ showLogo = true }: SidebarHeaderProps) {
  // Используем централизованную функцию для получения URL логотипа
  const logoUrl = getStorageUrl(buildLogoUrl());

  console.log('🖼️ SidebarHeader logoUrl:', logoUrl);

  return (
    <div className="flex flex-col p-2">
      {showLogo && (
        <div className="flex items-center justify-center mb-4 pt-2 pb-6 border-b border-sidebar-border bg-gradient-to-br from-[#064f4f] via-[#086161] to-[#0a7474] shadow-lg animate-glow rounded-xl">
          <Link to="/" className="flex flex-col items-center">
            <div className="mb-1">
              <img 
                src={logoUrl}
                alt="ТУК-ТУК" 
                className="h-32 w-auto" 
                onLoad={() => console.log('✅ Логотип успешно загружен')}
                onError={(e) => console.error('❌ Ошибка загрузки логотипа:', e)}
              />
            </div>
            <div className="font-bold text-2xl text-white font-russo tracking-wider">
              ТУК-ТУК PRO
            </div>
            <div className="text-xs text-white/80 text-center mt-0.5 px-4 font-medium">
              Профессиональная Аренда
            </div>
          </Link>
        </div>
      )}
    </div>
  );
}
